var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-wrapper u-margin-bottom u-margin-bottom-large@tablet"},[_c('h1',[_vm._v("We konden deze inhoud niet vinden")]),_c('p',[_c('router-link',{staticClass:"c-button c-button--ghost",attrs:{"to":{ name:'Home' }}},[_vm._v("\n      Terug naar overzicht\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }